import { API_PATHS } from '../constants/paths';
import type { AuthApi } from '../types/api';
import type { HttpClient } from '../types/httpClient';
import { send } from '../utils/send';
import { toApiPhone } from '../utils/toApiPhone';

/** Sign-in, registration, password reset and registration by link. Phones go in international format (`+57…`). */
export function createAuthApi(http: HttpClient): AuthApi {
    return {
        login: ({ phone, password }) =>
            send(http, 'raw', API_PATHS.AUTH_TOKEN, {
                method: 'POST',
                body: { username: toApiPhone(phone), password },
            }),

        refresh: (refreshToken: string) =>
            send(http, 'raw', API_PATHS.AUTH_TOKEN_REFRESH, {
                method: 'POST',
                body: { refresh_token: refreshToken },
            }),

        logout: () => send(http, 'raw', API_PATHS.AUTH_LOGOUT, { method: 'POST', body: {} }),

        registerRequest: (phone: string) =>
            send(http, 'raw', API_PATHS.AUTH_REGISTER_REQUEST, {
                method: 'POST',
                body: { phone: toApiPhone(phone) },
            }),

        registerComplete: ({ phone, code, password, referralCode }) =>
            send(http, 'raw', API_PATHS.AUTH_REGISTER_COMPLETE, {
                method: 'POST',
                body: {
                    phone: toApiPhone(phone),
                    code,
                    password,
                    ...(referralCode && { referral_code: referralCode }),
                },
            }),

        resetPasswordRequest: (phone: string) =>
            send(http, 'raw', API_PATHS.PASSWORD_RESET_REQUEST, {
                method: 'POST',
                body: { phone: toApiPhone(phone) },
            }),

        resetPasswordVerify: ({ phone, code }) =>
            send(http, 'raw', API_PATHS.PASSWORD_RESET_VERIFY, {
                method: 'POST',
                body: { phone: toApiPhone(phone), code },
            }),

        resetPasswordChange: ({ newPassword, newPasswordConfirmation }) =>
            send(http, 'raw', API_PATHS.PASSWORD_RESET_CHANGE, {
                method: 'POST',
                body: { new_password: newPassword, new_password_confirmation: newPasswordConfirmation },
            }),

        validateRegisterLink: (key: string) => send(http, 'raw', API_PATHS.REGISTER_LINK, { query: { key } }),

        resolveRegisterLink: (key: string) =>
            send(http, 'raw', API_PATHS.REGISTER_LINK, { method: 'POST', body: { key } }),
    };
}
